export default "__VITE_ASSET__DWcMSdQf__"